const jsonToProps = ({ box_credit_proposal: boxcreditproposal, ...props }) => ({ boxcreditproposal, ...props });

export default jsonToProps;
